<template>
  <app-page-container title="مدیریت کامپیوتر">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2" fab dark small @click="showSearchModal()" color="darkColor mt-3" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mr-n6 mt-6" v-if="isSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="2" class="text-left">
        <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
          class="mt-3 normal-letter-spacing ml-3">
          <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
          افزودن کامپیوتر
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="card-width body-card">
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table fixed-header :headers="clientComputerManagmentInformationTableHeaders"
                      :items="clientComputerPaginationList" :page.sync="page"
                      :items-per-page="clientComputerPaginationList.length" height="68vh" :hide-default-footer="true"
                      multi-sort :search="searchTitle" class="elevation-0">
                      <template v-slot:[`item.status`]="{ item }">
                        <v-row v-if="item.status === false">
                          <v-icon color="#F56060" v-bind="attrs" v-on="on">
                            mdi-close-circle mdi-18px
                          </v-icon>
                          <span class="mr-2 mt-1">تایید نشده</span>
                        </v-row>
                        <v-row v-else>
                          <v-icon color="#3BCA79">mdi-check-circle mdi-18px</v-icon>
                          <span class="mr-2 mt-1">تایید شده</span>
                        </v-row>
                      </template>
                      <template v-slot:[`item.active`]="{ item }">
                        <v-tooltip top v-if="item.active === false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#F56060" v-bind="attrs" v-on="on">
                              mdi-eye-off mdi-24px
                            </v-icon>
                          </template>
                          <span>غیر فعال</span>
                        </v-tooltip>
                        <v-tooltip top v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#3BCA79" v-bind="attrs" v-on="on">
                              mdi-eye mdi-24px
                            </v-icon>
                          </template>
                          <span>فعال</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                              @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                              mdi-pencil
                            </v-icon>
                          </template>
                          <span>ویرایش</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                              @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>حذف</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-0">
          <pagination-component ref="pagination">
            <div slot="action">
              <v-card elevation="0">
                <v-pagination class="mt-8" circle color="lightColor" v-model="page" :length="totalPages"
                  :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                  @next="next()" @previous="previous()" @input="input()"></v-pagination>
              </v-card>
            </div>
          </pagination-component>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
        <v-dialog width="450" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-magnify</v-icon>
                  <span class="modal-title-text mr-2">جستجو</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchUniqueId" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="شناسه"
                    class="input-label" prepend-inner-icon="mdi-text-box mdi-18px" tabindex="1"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchComputerTitle" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="نام کامپیوتر"
                    class="input-label" prepend-inner-icon="mdi-laptop mdi-18px" tabindex="1"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete hide-details :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="شهر" @change="searchCityChange()" v-model="searchCityId" autocomplete="off"
                    prepend-inner-icon="mdi-home-city mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete hide-details :items="allExtensionsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="sipExtension" item-value="id"
                    label="داخلی" v-model="searchExtensionId" autocomplete="off"
                    prepend-inner-icon="mdi-home-city mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete hide-details :items="allZonesForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="ناحیه" v-model="searchZoneId" autocomplete="off"
                    prepend-inner-icon="mdi-home-city mdi-18px"></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="450" v-model="showAddEditModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">{{ modalIcon }}</v-icon>
                  <span class="modal-title-text mr-2">{{ modalTitle }}</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-text-field type="text" v-model="clientComputer.title" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                    label="نام کامپیوتر*" :autofocus="true" class="input-label"
                    prepend-inner-icon="mdi-text-box mdi-18px" tabindex="1"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline"
                    v-model="clientComputer.uniqueId" dense outlined v-on:keyup.enter="showConfirmDialogFunction()"
                    label="شناسه*" class="input-label" prepend-inner-icon="mdi-text mdi-18px"
                    tabindex="2"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="4" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="شهر" @change="cityChange()" v-model="selectedCity" autocomplete="off"
                    prepend-inner-icon="mdi-home-city mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-autocomplete :items="allExtensionsForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="3" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="sipExtension" item-value="id"
                    label="داخلی" v-model="clientComputer.extensionId" autocomplete="off"
                    prepend-inner-icon="mdi-home-city mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-autocomplete :items="allZonesForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="5" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="ناحیه" v-model="clientComputer.zoneId" autocomplete="off"
                    prepend-inner-icon="mdi-home-city mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-textarea type="text" clearable clear-icon="mdi-close-circle-outline" v-model="clientComputer.note"
                    dense outlined rows="4" v-on:keyup.enter="showConfirmDialogFunction()" label="توضیحات"
                    class="input-label" prepend-inner-icon="mdi-text mdi-18px" tabindex="6"></v-textarea>
                </v-col>
                <v-col cols="6" v-if="!addFlag">
                  <v-checkbox v-model="isConfirmed" label="تایید" hide-details tabindex="7"></v-checkbox>
                </v-col>
                <v-col cols="6" v-if="!addFlag">
                  <v-checkbox v-model="isActive" label="فعال" hide-details tabindex="8"></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import PaginationComponent from '../../components/PaginationComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import clientComputerMixin from '@/Mixins/BaseInformation/ClientComputerMixin';
import ExtensionMixin from '@/Mixins/BaseInformation/ExtensionMixin';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import clientComputerHelper from '@/Helpers/BaseInformation/ClientComputerHelper.js';
export default {
  name: 'ClientComputerManagment',
  title: 'کامپیوتر',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    PaginationComponent,
    AppPageContainer,
  },
  mixins: [
    pagination,
    ShearedMixin,
    clientComputerMixin,
    clientComputerHelper,
    snackBar,
    ShearedHelper,
    ZoneMixin,
    CityMixin,
    ExtensionMixin,
  ],
  created() {
    this.$root.$refs.ClientComputerManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfClientComputersWithPagination();
      this.getListOfCitysForOther();
    },
    previous: function () {
      this.getListOfClientComputersWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfClientComputersWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfClientComputersWithPagination();
      this.$refs.pagination.page = this.page;
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
